var scope_0 = require('/builds/pathcore/docs/scholar-docs/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/5773867a9d22729f0af08329f92d84bf.js').default;

var scope_1 = require('/builds/pathcore/docs/scholar-docs/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e92f8988d65cf25c087d226e6c0ef06f.js').default;

export default Object.assign({}, scope_0, scope_1);